export const MOBILE_CASHIER = 'mobile-cashier';
